import React, { useContext } from 'react';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { useMeasureElementCookie } from '@wix/da-hooks/pkg/useMeasureElement/useMeasureElementCookie';
import { MeasuredCookieType } from '@wix/da-hooks/pkg/useMeasureElement/redux/types';
import { BiLoggerContextProvider } from '@wix/da-bi/pkg/BiLogger.context';
import { ResourceType } from '../../../../types/resource';
import SellerCard from '../../../../SellerCard';
import s from './ShopBlock.scss';
// 308 (sidebar width - padding) - 2 (borders) = 306
const CARD_WIDTH = 306;
const ShopBlock = ({ block: { contentType: biSectionName }, user, deviations, link })=>{
    const isMobile = useContext(MobileContext);
    // note: this only works inside the slider bc .root is set to width 100%
    // otherwise, the width would be the entire slider (2-3x the card width)
    const { ref, dimensions } = useMeasureElementCookie(MeasuredCookieType.DEVIATION_SIDEBAR, {
        cookieDim: 'width'
    });
    return /*#__PURE__*/ React.createElement(BiLoggerContextProvider, {
        value: {
            sectionid: user.userId,
            section_typeid: ResourceType.USER,
            sectionname: biSectionName
        }
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['root'],
        ref: ref
    }, /*#__PURE__*/ React.createElement(SellerCard, {
        width: isMobile ? dimensions.width : CARD_WIDTH,
        multiArt: true,
        user: user,
        deviations: deviations,
        link: link,
        withShopCta: true
    })));
};
ShopBlock.displayName = 'ShopBlock';
export default ShopBlock;

//# sourceMappingURL=ShopBlock.js.map